module.exports = __webpack_public_path__ + "f1b8e364a7dd0a8f3fb51316f7cac573.svg";